import { render, staticRenderFns } from "./Tablet.vue?vue&type=template&id=c57b5360&scoped=true&"
import script from "./Tablet.vue?vue&type=script&lang=js&"
export * from "./Tablet.vue?vue&type=script&lang=js&"
import style0 from "./Tablet.vue?vue&type=style&index=0&id=c57b5360&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c57b5360",
  null
  
)

export default component.exports